import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface ObjetivoDB {
  id: number;
  orden: string;
  titulo: string;
  descripcion: string;
  created_at: string;
}

export function useObjetivos() {
  const [data, setData] = useState<ObjetivoDB[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from("objetivos")
        .select("*")
        .order("orden", { ascending: true });
      if (err) throw err;
      setData(result as ObjetivoDB[] ?? []);
    } catch {
      setError("Error cargando objetivos");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}